import { transformIcon } from '@/helpers/transforms'
import type { TextWithIconAsideBlock } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import { CMSBlocks } from '../atoms/CMSBlocks'
import { IconCopyBlock } from '../blocks/IconCopyBlock'

export const TextWithIconAsideConverter: JSXConverter<
	SerializedBlockNode<TextWithIconAsideBlock>
> = ({ node, nodesToJSX }) => {
	const { content, icon, layout } = node.fields

	const columnLayout = layout === 'icon-on-left' ? 'default' : 'reverse'

	const imageData = transformIcon(icon)

	return (
		<IconCopyBlock iconImage={imageData} layout={columnLayout}>
			<CMSBlocks>{nodesToJSX({ nodes: content?.root?.children ?? [] })}</CMSBlocks>
		</IconCopyBlock>
	)
}
